<template lang="html">
  <div class="">
    <AssistanceRequest v-if="$route.name === 'assistance'" />
    <AssistanceView v-if="$route.name === 'assistance_view'" />
  </div>
</template>

<script>

export default {
  data () {
    return {

    }
  },
  computed: {
    // ...mapGetters([]),
  },
  methods: {

  }
}
</script>

<style lang="css" scoped>

</style>
